import { Button } from "@/components/ui/button";
import { ArrowLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";
export const EmptyCart = () => {
  const navigate = useNavigate();
  return <div className="min-h-screen bg-background py-12">
      <div className="container mx-auto px-4">
        
        <div className="text-center space-y-4">
          <h1 className="text-2xl font-bold mb-4">Your Cart is Empty</h1>
          <p className="text-muted-foreground">Add some delicious meals to get started!</p>
          <Button onClick={() => navigate("/")} size="lg">Browse Meals</Button>
        </div>
      </div>
    </div>;
};